var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDefaultCategory = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  className: "SideBarListItemHeaderStyles__StyledInboxCategoryDefaultIcon-sc-nwrg8l-6 jcCELw",
  viewBox: "0 0 30 30",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#089BD7",
  d: "m4 19 5.5-3.2 1.375-.8M26 19l-5.5-3.2-1.375-.8"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#1859A9",
  d: "M.938 7.438 15 18.124 29.063 7.438"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#1859A9",
  d: "M2.787 3.75 15 13.125 27.212 3.75"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#1859A9",
  d: "M27.188 3.75H2.813c-1.036 0-1.876.84-1.876 1.875v18.75c0 1.035.84 1.875 1.876 1.875h24.375c1.035 0 1.875-.84 1.875-1.875V5.625c0-1.036-.84-1.875-1.875-1.875"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultCategory);
export default ForwardRef;